import { createContext } from 'react';

export const ErxAdviceContext = createContext({});
export const ErxAdviceDispatchContext = createContext(null);